const $window = $(window);
const $body = $("body");

export function isVisible(el) {
  let elementTop = $(el).offset().top;
  let elementHeight = $(el).outerHeight();

  let viewportTop = $window.scrollTop();
  let viewportBottom = viewportTop + $window.height();

  // Check if certain chunks are visible (large elements)
  for (let i = 1; i < 20; i++) {
    let height = (elementHeight / 10) * i;
    let top = elementTop + (height - (elementHeight / 10));
    let bottom = elementTop + height;

    if (bottom > viewportTop && top < viewportBottom) {
      return true;
    }
  }

  return false;
}


// WEBPACK FOOTER //
// ./js/functions.js